export default __webpack_public_path__ + "static/media/snake.e173c911.svg";